/*==================================================
DREAMY DERMA CART V2
==================================================*/

const DD = {

    FREE_GIFT_VARIANT: 52092361670957,

    GOAL_SHIPPING: 199,

    GOAL_10: 501,

    GOAL_15: 700,

    GOAL_GIFT: 999,
    GIFT_POPUP_SHOWN: false,
    PROGRESS_POSITIONS:{

    START:0,

    SHIPPING:26,

    GOAL501:36,

    GOAL700:77,

    GOAL999:100

},
    CART_LOADING: false,

    TIMER_END: null,
    POPUP_SHOWN: false,
    LAST_GIFT_STATE: null,

    MILESTONE_STATE: {
    shipping: false,
    goal501: false,
    goal700: false,
    goal999: false
},

    _refreshDebounce: null,
    _refreshQueued: false,

    /* NEW: true when the cart holds a freebie it is not allowed to have */
    FREEBIE_INVALID: false,

};



(function(){

    const CART_ENDPOINTS = [
        "/cart/add.js",
        "/cart/change.js",
        "/cart/update.js",
        "/cart/clear.js"
    ];

    const originalFetch = window.fetch;

    function isFreebieVariant(value){

        if(value === null || value === undefined){
            return false;
        }

        return String(value) === String(DD.FREE_GIFT_VARIANT);

    }


    /* ==========================================
       NEW: /cart/update.js can ADD a new line
       with  { updates: { VARIANT_ID: qty } }
       Block that for the freebie variant.
    ========================================== */

    function updateRequestAddsFreebie(body){

        if(!body || typeof body !== "string"){
            return false;
        }

        try{

            const data = JSON.parse(body);

            if(
                data &&
                data.updates &&
                typeof data.updates === "object" &&
                !Array.isArray(data.updates)
            ){

                return Object.keys(data.updates).some(function(key){

                    const variantPart = String(key).split(":")[0];

                    return (
                        isFreebieVariant(variantPart) &&
                        Number(data.updates[key]) > 0
                    );

                });

            }

        }catch(error){}

        return false;

    }


    function requestContainsFreebie(body){

        if(!body){
            return false;
        }


        /* ==========================================
           JSON BODY
        ========================================== */

        if(typeof body === "string"){

            try{

                const data = JSON.parse(body);

                if(data && Array.isArray(data.items)){

                    return data.items.some(function(item){

                        return item &&
                               isFreebieVariant(
                                   item.id ||
                                   item.variant_id
                               );

                    });

                }

                if(data && isFreebieVariant(data.id)){
                    return true;
                }

                if(data && isFreebieVariant(data.variant_id)){
                    return true;
                }

            }catch(error){

                /* Not JSON */

            }


            /* ==========================================
               URL ENCODED BODY
            ========================================== */

            try{

                const params = new URLSearchParams(body);

                const id = params.get("id");

                if(isFreebieVariant(id)){
                    return true;
                }

            }catch(error){}

        }


        /* ==========================================
           FORM DATA
        ========================================== */

        if(typeof FormData !== "undefined" &&
           body instanceof FormData){

            const id = body.get("id");

            if(isFreebieVariant(id)){
                return true;
            }

            const items = body.get("items");

            if(items){

                try{

                    const parsed =
                        typeof items === "string"
                        ? JSON.parse(items)
                        : items;

                    if(Array.isArray(parsed)){

                        return parsed.some(function(item){

                            return item &&
                                   isFreebieVariant(
                                       item.id ||
                                       item.variant_id
                                   );

                        });

                    }

                }catch(error){}

            }

        }


        return false;

    }


    window.fetch = function(...args){

        const urlArg = args[0];

        const url =
            typeof urlArg === "string"
            ? urlArg
            : (urlArg && urlArg.url) || "";


        const options = args[1] || {};

        const isCartMutation =
            CART_ENDPOINTS.some(function(endpoint){

                return url.indexOf(endpoint) !== -1;

            });


        /* ==========================================
           FREEBIE DIRECT ADD PROTECTION
           
           ONLY giftEngine is allowed to add
           the freebie variant.
        ========================================== */

        if(
            (
                (
                    url.indexOf("/cart/add.js") !== -1 &&
                    requestContainsFreebie(options.body)
                ) ||
                (
                    url.indexOf("/cart/update.js") !== -1 &&
                    updateRequestAddsFreebie(options.body)
                )
            ) &&
            !window.DD_GIFT_ENGINE_ADDING
        ){

            console.warn(
                "DD FREEBIE BLOCKED: Direct freebie add."
            );


            return Promise.resolve(
                new Response(
                    JSON.stringify({
                        status: 422,
                        message:
                            "This product is available only as a free gift on qualifying orders."
                    }),
                    {
                        status: 422,
                        headers:{
                            "Content-Type":
                                "application/json"
                        }
                    }
                )
            );

        }


        const request =
            originalFetch.apply(this, args);


        if(isCartMutation){

            /*
             * NEW: if a cart change happens while a refresh is
             * already running (and it is not our own gift-engine
             * change), queue another refresh so the freebie rules
             * are re-checked against the latest cart.
             */

            if(
                DD.CART_LOADING &&
                !window.DD_GIFT_ENGINE_RUNNING
            ){

                request.then(function(res){

                    if(res && res.ok){
                        DD._refreshQueued = true;
                    }

                }).catch(function(){});

            }

            else if(!DD.CART_LOADING){

                request.then(function(res){

                    if(res && res.ok){

                        clearTimeout(
                            DD._refreshDebounce
                        );

                        DD._refreshDebounce =
                            setTimeout(function(){

                                refreshCart();

                            }, 200);

                    }

                }).catch(function(){});

            }

        }


        return request;

    };

})();


document.addEventListener("DOMContentLoaded", initDDCart);
document.addEventListener("input", function(e){

    if(!e.target.matches(".dd-coupon-search-input")) return;

    const applyBtn = document.querySelector(".dd-coupon-apply");

    if(applyBtn){

        applyBtn.disabled = e.target.value.trim() === "";

    }

});

function initDDCart(){

    initCountdown();

    bindAccordions();

    refreshCart();

    document.addEventListener("cart:updated", function(){

    setTimeout(function(){

        refreshCart();

    },150);

});

    // document.addEventListener("product-ajax:added", function(){

    //     setTimeout(refreshCart,300);

    // });

}

/*==================================================
CART LOADER
==================================================*/

function showCartLoader(){

    const loader = document.getElementById("ddCartLoader");

    if(loader){
        loader.classList.add("active");
    }

}

function hideCartLoader(){

    const loader = document.getElementById("ddCartLoader");

    if(loader){
        loader.classList.remove("active");
    }

}


/*==================================================
FREEBIE RULES (NEW)

The freebie is ONLY allowed when:

1. The cart has at least one real product
   (normal product or bundle).
   Freebie / Gift Card / Keraboost alone = NO.

2. Qualifying subtotal is ₹999 or more.
   Counts: normal products + bundles
   Does NOT count: freebie, gift card, keraboost.

Otherwise the freebie must not be in the cart.
==================================================*/

function ddFreebieState(cart){

    const items =
        cart && Array.isArray(cart.items)
        ? cart.items
        : [];

    const gifts = items.filter(function(item){

        return item &&
               item.variant_id == DD.FREE_GIFT_VARIANT;

    });

    let hasRealProduct = false;

    const qualifyingSubtotal = items.reduce(function(total, item){

        if(!item){
            return total;
        }

        if(item.variant_id == DD.FREE_GIFT_VARIANT){
            return total;
        }

        if(isKeraboost(item)){
            return total;
        }

        if(isGiftCard(item)){
            return total;
        }

        hasRealProduct = true;

        return total + (
            item.original_line_price ||
            item.final_line_price ||
            0
        );

    }, 0) / 100;

    return {
        gifts: gifts,
        hasRealProduct: hasRealProduct,
        qualifyingSubtotal: qualifyingSubtotal,
        eligible: hasRealProduct &&
                  qualifyingSubtotal >= DD.GOAL_GIFT
    };

}

function ddFreebieIsInvalid(cart){

    const state = ddFreebieState(cart);

    if(state.gifts.length === 0){
        return false;
    }

    if(!state.eligible){
        return true;
    }

    if(state.gifts.length > 1){
        return true;
    }

    return state.gifts[0].quantity !== 1;

}

/*
 * Removes the freebie right now if the cart is not allowed to have it.
 * Used as a last check right before checkout.
 */

async function ddSanitizeFreebie(){

    try{

        const cart = await fetch("/cart.js").then(r => r.json());

        const state = ddFreebieState(cart);

        if(state.gifts.length === 0 || state.eligible){
            return;
        }

        for(const gift of state.gifts){

            if(!gift.key){
                continue;
            }

            await fetch("/cart/change.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    id: gift.key,
                    quantity: 0
                })
            });

        }

    }catch(error){

        console.error("DD FREEBIE SANITIZE ERROR:", error);

    }

}

/*
 * CHECKOUT GUARD
 *
 * If the cart currently holds an invalid freebie (or the cart is
 * still refreshing), stop the checkout click, clean the cart, and
 * then continue. Add your own checkout button selector below if it
 * is not already covered (Fastrr / Shiprocket button etc.).
 */

document.addEventListener("click", async function(e){

    const trigger = e.target.closest(
        'button[name="checkout"], input[name="checkout"], a[href^="/checkout"], .cart__checkout-button, .dd-checkout-btn, [data-checkout], #fastrr-btn, .fastrr-btn, .shiprocket-checkout'
    );

    if(!trigger) return;

    if(trigger.dataset.ddFreebieChecked === "1"){
        delete trigger.dataset.ddFreebieChecked;
        return;
    }

    if(!DD.CART_LOADING && !DD.FREEBIE_INVALID) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    await ddSanitizeFreebie();

    let cart = null;

    try{
        cart = await fetch("/cart.js").then(r => r.json());
    }catch(error){}

    DD.FREEBIE_INVALID = cart ? ddFreebieIsInvalid(cart) : false;

    refreshCart();

    if(!cart || cart.item_count === 0){
        return;
    }

    trigger.dataset.ddFreebieChecked = "1";
    trigger.click();

}, true);


/*==================================================
REFRESH CART
==================================================*/

async function refreshCart(){

    
    if(DD.CART_LOADING){
        DD._refreshQueued = true;
        return;
    }

    DD.CART_LOADING = true;
    showCartLoader();

    document.querySelectorAll(".quantity__button").forEach(btn=>{
        btn.disabled = true;
    });

    document.querySelectorAll(".quantity__input").forEach(input=>{
        input.disabled = true;
    });

    document.querySelectorAll(".cart-item").forEach(item=>{
        item.classList.add("dd-loading");
    });

    try{


        
        // FIRST FETCH
        let cart = await fetch("/cart.js").then(r=>r.json());

        // ADD / REMOVE GIFT
const giftResult = await giftEngine(cart);

// ==================================================
// SHIPROCKET HANDLES MOIZ FREEBIES
// Custom cart gift engine disabled.
// ==================================================
// const giftResult = null;

if (giftResult && giftResult.cart) {
cart = giftResult.cart;
} else {
cart = await fetch("/cart.js").then(r => r.json());
}

/* NEW: remember whether the cart still has a freebie it should not have */
DD.FREEBIE_INVALID = ddFreebieIsInvalid(cart);


if(giftResult && giftResult.changed && giftResult.popup){

const giftItem = cart.items.find(item =>
    item.variant_id == DD.FREE_GIFT_VARIANT
);

showPopup(
    giftResult.popup.title,
    giftResult.popup.description ||
    // `You saved ${formatMoney(giftItem ? giftItem.price : 0)} with this freebie.`,
    `You saved ₹49 with this freebie.`,
    giftResult.popup.celebrate
);

if(giftResult.popup.celebrate){
    playConfetti();
}
}

//     const drawer = document.querySelector("cart-drawer");

// if (drawer && typeof drawer.onCartRefresh === "function") {
//     await drawer.onCartRefresh({
//         detail: {
//             open: true
//         }
//     });
// }
// else {
//     console.warn("Cart drawer or onCartRefresh() not found.");
// }

        const notePreview = document.querySelector(".dd-note-preview");

        if(notePreview){

            notePreview.innerHTML =
                cart.note && cart.note.trim()
                ? cart.note
                : "Add a personalised note";

        }

        const textarea = document.querySelector(".dd-note-text");

        if(textarea){

            textarea.value = cart.note || "";

        }

        updateProgress(cart);

        updateTotals(cart);
        

        updateSavings(cart);

        updateCartCount(cart);

        updateProgressMessage(cart);

        updateProgressIcons(cart);

        checkMilestones(cart);

        loadUpsellProducts(cart).catch(function(err){});

        const card = document.querySelector(".dd-cart-card");

        if(card){

            card.classList.toggle("hide", cart.item_count === 0);

        }

    }

    catch(error){

    }

    finally{
        hideCartLoader();        
        DD.CART_LOADING = false;

        document.querySelectorAll(".quantity__button").forEach(btn=>{
            btn.disabled = false;
        });

        document.querySelectorAll(".quantity__input").forEach(input=>{
            input.disabled = false;
        });

        document.querySelectorAll(".cart-item").forEach(item=>{
            item.classList.remove("dd-loading");
        });

  
        if(DD._refreshQueued){

            DD._refreshQueued = false;

            refreshCart();

        }

    }

}


    /*==================================================
PROGRESS
==================================================*/

   function updateProgress(cart){

/*==================================================
CART PROGRESS RULES

FREE SHIPPING
- Normal products COUNT
- Keraboost COUNTS
- Gift Cards COUNT
- Bundles DO NOT count
- Free gift does NOT count

10% / 15%
- Normal products COUNT
- Keraboost does NOT count
- Gift Cards do NOT count
- Bundles do NOT count
- Free gift does NOT count

₹999 FREE GIFT
- Normal products COUNT
- Bundles COUNT
- Keraboost does NOT count
- Gift Cards do NOT count
- Free gift does NOT count
==================================================*/


/*==================================================
1. SHIPPING SUBTOTAL
==================================================*/

const shippingSubtotal = cart.items.reduce((total, item) => {

    if (item.variant_id == DD.FREE_GIFT_VARIANT) {
        return total;
    }

    if (isBundle(item)) {
        return total;
    }

    return total + (
        item.original_line_price ||
        item.final_line_price
    );

}, 0) / 100;


/*==================================================
2. REGULAR DISCOUNT SUBTOTAL
₹501 / ₹700

Keraboost excluded
Gift Card excluded
Bundle excluded
==================================================*/

const regularSubtotal = cart.items.reduce((total, item) => {

    if (item.variant_id == DD.FREE_GIFT_VARIANT) {
        return total;
    }

    if (isGiftCard(item)) {
        return total;
    }

    if (isBundle(item)) {
        return total;
    }

    if (isKeraboost(item)) {
        return total;
    }

    return total + (
        item.original_line_price ||
        item.final_line_price
    );

}, 0) / 100;


/*==================================================
3. FREE GIFT SUBTOTAL
₹999

Keraboost excluded
Gift Card excluded
Bundle INCLUDED
==================================================*/

const freeGiftSubtotal = cart.items.reduce((total, item) => {

    if (item.variant_id == DD.FREE_GIFT_VARIANT) {
        return total;
    }

    if (isGiftCard(item)) {
        return total;
    }

    if (isKeraboost(item)) {
        return total;
    }

    return total + (
        item.original_line_price ||
        item.final_line_price
    );

}, 0) / 100;


/*==================================================
4. CART CONDITIONS
==================================================*/

const hasBundle = cart.items.some(item => {

    if (item.variant_id == DD.FREE_GIFT_VARIANT) {
        return false;
    }

    return isBundle(item);

});


const hasKeraboost = cart.items.some(item => {

    if (item.variant_id == DD.FREE_GIFT_VARIANT) {
        return false;
    }

    return isKeraboost(item);

});


const hasGiftCard = cart.items.some(item => {

    if (item.variant_id == DD.FREE_GIFT_VARIANT) {
        return false;
    }

    return isGiftCard(item);

});


/*==================================================
5. ACTUALLY DISCOUNTED PRODUCTS
==================================================*/

let discountSubtotal = regularSubtotal;


const discountedItems = cart.items.filter(item => {

    if (item.variant_id == DD.FREE_GIFT_VARIANT) {
        return false;
    }

    if (isBundle(item)) {
        return false;
    }

    if (isGiftCard(item)) {
        return false;
    }

    if (isKeraboost(item)) {
        return false;
    }

    return (
        item.discounts &&
        Array.isArray(item.discounts) &&
        item.discounts.length > 0
    );

});


if (discountedItems.length > 0) {

    discountSubtotal = discountedItems.reduce(
        (total, item) => {

            return total + (
                item.original_line_price ||
                item.final_line_price
            );

        },
        0
    ) / 100;

}

else if (regularSubtotal >= DD.GOAL_10) {

    /*
     * ₹501+ normal products exist,
     * but Shopify has not actually
     * applied the discount yet.
     *
     * Therefore do not show the
     * discount milestone as active.
     */

    discountSubtotal = 0;

}


/*==================================================
6. PROGRESS POSITION
==================================================*/

const P = DD.PROGRESS_POSITIONS;

let progress = 0;


/*==================================================
GIFT CARD ONLY
==================================================*/

if (
    hasGiftCard &&
    regularSubtotal === 0 &&
    freeGiftSubtotal === 0
) {

    progress =
        P.SHIPPING +
        (P.GOAL501 - P.SHIPPING) * 0.8;

}


/*==================================================
KERABOOST ONLY

Keraboost gets Free Shipping,
but NOT 10%, 15%, or Free Gift.
==================================================*/

else if (
    hasKeraboost &&
    regularSubtotal === 0 &&
    freeGiftSubtotal === 0
) {

    progress =
        P.SHIPPING +
        (P.GOAL501 - P.SHIPPING) * 0.8;

}


/*==================================================
BUNDLE BELOW ₹501

IMPORTANT:
Bundle can still qualify for the ₹999 FREE GIFT.

So this condition should ONLY run when
the cart has NOT reached ₹999 yet.
==================================================*/

else if (
    hasBundle &&
    regularSubtotal < DD.GOAL_10 &&
    freeGiftSubtotal < DD.GOAL_GIFT
) {

    progress =
        P.SHIPPING +
        (P.GOAL501 - P.SHIPPING) * 0.8;

}


/*==================================================
₹999 FREE GIFT

Bundles COUNT toward ₹999.

So if a bundle itself is ₹999+,
the progress bar must go FULL.
==================================================*/

else if (
    freeGiftSubtotal >= DD.GOAL_GIFT
) {

    progress = P.GOAL999;

}


/*==================================================
₹700 / 15% OFF
==================================================*/

else if (
    discountSubtotal >= DD.GOAL_15
) {

    progress =
        P.GOAL700 +
        (
            (discountSubtotal - DD.GOAL_15) /
            (DD.GOAL_GIFT - DD.GOAL_15)
        ) *
        (P.GOAL999 - P.GOAL700);

}


/*==================================================
₹501 / 10% OFF
==================================================*/

else if (
    discountSubtotal >= DD.GOAL_10
) {

    progress =
        P.GOAL501 +
        (
            (discountSubtotal - DD.GOAL_10) /
            (DD.GOAL_15 - DD.GOAL_10)
        ) *
        (P.GOAL700 - P.GOAL501);

}


/*==================================================
₹199 → ₹501

USE REGULAR SUBTOTAL

Keraboost does NOT count here.
==================================================*/

else if (
    regularSubtotal >= DD.GOAL_SHIPPING
) {

    progress =
        P.SHIPPING +
        (
            (regularSubtotal - DD.GOAL_SHIPPING) /
            (DD.GOAL_10 - DD.GOAL_SHIPPING)
        ) *
        (P.GOAL501 - P.SHIPPING);

}


/*==================================================
BELOW ₹199

IMPORTANT:
Use SHIPPING subtotal here.

This means Keraboost can unlock
Free Shipping progress.
==================================================*/

else {

    progress =
        (
            shippingSubtotal /
            DD.GOAL_SHIPPING
        ) *
        P.SHIPPING;

}


/*==================================================
SAFETY
==================================================*/

progress = Math.max(
    0,
    Math.min(progress, 100)
);


/*==================================================
UPDATE PROGRESS BAR
==================================================*/

const bar = document.querySelector(
    "[data-progress]"
);

if (bar) {

    requestAnimationFrame(function(){

        bar.style.width =
            progress + "%";

    });

}

}

/*==================================================
TOTALS + SAVINGS + CART COUNT
==================================================*/

function formatMoney(cents){

    if(window.Shopify && typeof Shopify.formatMoney === "function"){

        return Shopify.formatMoney(cents);

    }

    return "₹" + (cents / 100).toFixed(2).replace(/\.00$/, "");

}

   

function updateTotals(cart){

    const subtotal = cart.items.reduce(function(total, item){

if(item.variant_id == DD.FREE_GIFT_VARIANT){
return total;
}



return total + (item.original_line_price || item.final_line_price);

}, 0);

const discount = cart.total_discount;

const freeGift = cart.items.find(function(item){
return item.variant_id == DD.FREE_GIFT_VARIANT;
});

const freeGiftValue = freeGift ? freeGift.price : 0;

// Final Total = Subtotal - Discount
const finalTotal = subtotal - discount;

    document.querySelectorAll("[data-cart-total]").forEach(function(el){

        el.innerHTML = formatMoney(finalTotal);

    });

    const originalPrice = cart.items.reduce(function(total,item){

    if(item.variant_id == DD.FREE_GIFT_VARIANT){
return total;
}



    return total + (item.original_line_price || item.final_line_price);

},0);

    document.querySelectorAll("[data-cart-original]").forEach(function(el){

        if(originalPrice > cart.total_price){

            // el.innerHTML = "MRP " + formatMoney(originalPrice);
            el.innerHTML = formatMoney(originalPrice);

            el.style.display = "inline-block";

        }else{

            el.style.display = "none";

        }

    });

    document.querySelectorAll("[data-summary-total]").forEach(function(el){

    el.innerHTML = formatMoney(finalTotal);

});

    const discountLabel = document.querySelector(".dd-discount-label");

if(discountLabel){

    if (discount > 0) {

if (subtotal >= DD.GOAL_15 * 100) {
    discountLabel.innerHTML = "Auto discount (15% OFF)";
} else if (subtotal >= DD.GOAL_10 * 100) {
    discountLabel.innerHTML = "Auto discount (10% OFF)";
} else {
    discountLabel.innerHTML = "Auto discount";
}

discountLabel.style.color = "#238017";

} else {

discountLabel.innerHTML = "Auto discount";

}

}

// document.querySelectorAll("[data-summary-discount]").forEach(function(el){

//     el.innerHTML = "-" + formatMoney(discount);

//     el.style.color = "#238017";

// });

document.querySelectorAll("[data-summary-discount]").forEach(function(el){
if (cart.total_discount > 0) {
    el.innerHTML = "-" + formatMoney(cart.total_discount);
} else {
    el.innerHTML = "-₹0";
}
});



const freeGiftRow = document.querySelector(".dd-freebie-row");

if(freeGift){

    freeGiftRow.style.display = "flex";



    document
.querySelectorAll("[data-summary-freegift]")
.forEach(function(el){
el.innerHTML = "Free";
});

}else{

    freeGiftRow.style.display = "none";

}

    const label = document.getElementById("ddDiscountLabel");

if(label){

    if(subtotal >= 70000){

        label.innerHTML = "Auto discount (15% OFF)";

    }
    else if(subtotal >= 50100){

        label.innerHTML = "Auto discount (10% OFF)";

    }
    else{

        label.innerHTML = "Auto discount";

    }

}

    document.querySelectorAll("[data-summary-subtotal]").forEach(function(el){

    el.innerHTML = formatMoney(subtotal);

});

}

function updateSavings(cart){

    document.querySelectorAll("[data-cart-saving]").forEach(function(el){

        el.innerHTML = formatMoney(cart.total_discount);

    });

    document.querySelectorAll("[data-total-saving]").forEach(function(el){

        el.innerHTML = formatMoney(cart.total_discount);

    });

}

function updateCartCount(cart){

    document.querySelectorAll(".cart-count").forEach(function(el){

        el.innerHTML = cart.item_count;

    });

}

/*==================================================
PROGRESS MESSAGE + ICONS
==================================================*/

function updateProgressMessage(cart){

/*==================================================
REGULAR ELIGIBLE SUBTOTAL

Keraboost does NOT count.
Gift Card does NOT count.
Bundle does NOT count.
Free gift does NOT count.
==================================================*/

const subtotal = cart.items.reduce((total, item) => {

    // Free gift does not count
    if (item.variant_id == DD.FREE_GIFT_VARIANT) {
        return total;
    }

    // Gift Card does not count
    if (isGiftCard(item)) {
        return total;
    }

    // Bundle does not count
    if (isBundle(item)) {
        return total;
    }

    // Keraboost does not count
    if (isKeraboost(item)) {
        return total;
    }

    return total + (
        item.original_line_price ||
        item.final_line_price
    );

}, 0) / 100;


const msg = document.querySelector(
    ".dd-progress-message"
);

if (!msg) return;


/*==================================================
BELOW ₹501
==================================================*/

if (subtotal < DD.GOAL_10) {

    msg.innerHTML =
        "Add ₹" +
        Math.ceil(DD.GOAL_10 - subtotal) +
        " more to unlock <strong>10% OFF</strong>";

}


/*==================================================
₹501 → ₹700
==================================================*/

else if (subtotal < DD.GOAL_15) {

    msg.innerHTML =
        "Add ₹" +
        Math.ceil(DD.GOAL_15 - subtotal) +
        " more to unlock <strong>15% OFF</strong>";

}


/*==================================================
₹700 → ₹999
==================================================*/

else if (subtotal < DD.GOAL_GIFT) {

    msg.innerHTML =
        "Add ₹" +
        Math.ceil(DD.GOAL_GIFT - subtotal) +
        " more to unlock <strong>FREE GIFT</strong>";

}


/*==================================================
ALL REWARDS
==================================================*/

else {

    msg.innerHTML =
        "🎉 Congratulations! All rewards unlocked.";

}

}

function updateProgressIcons(cart){

// ==========================================
// NORMAL SUBTOTAL
// Used for Free Shipping + Free Gift
// ==========================================

// ==========================================
// SHIPPING / NORMAL SUBTOTAL
// Gift Cards COUNT for Free Shipping
// Gift Cards do NOT count for discounts/free gift
// ==========================================

const subtotal = cart.items.reduce((total, item) => {

// Free gift does not count
if (item.variant_id == DD.FREE_GIFT_VARIANT) {
    return total;
}

// Bundles do not count
if (isBundle(item)) {
    return total;
}

// Gift Cards COUNT toward Free Shipping
return total + (item.original_line_price || item.final_line_price);

}, 0) / 100;


// ==========================================
// REGULAR SUBTOTAL
// Gift Cards do NOT count toward
// 10% / 15% / ₹999 Free Gift
// ==========================================

const regularSubtotal = cart.items.reduce((total, item) => {

// Free gift does not count
if (item.variant_id == DD.FREE_GIFT_VARIANT) {
    return total;
}

// Gift Cards do NOT count toward discounts/free gift
if (isGiftCard(item)) {
    return total;
}

// Bundles do not count
if (isBundle(item)) {
return total;
}

// Keraboost does NOT count toward
// ₹501 / ₹700 discount progress
if (isKeraboost(item)) {
return total;
}

return total + (
item.original_line_price ||
item.final_line_price
);

}, 0) / 100;

// ==========================================
// FREE GIFT SUBTOTAL
// Gift Cards do NOT count
// Bundles DO count
// Normal products DO count
// Freebie does NOT count
// ==========================================

const freeGiftSubtotal = cart.items.reduce((total, item) => {

// Free gift does not count
if (item.variant_id == DD.FREE_GIFT_VARIANT) {
    return total;
}

// Gift Cards do NOT count toward ₹999
if (isGiftCard(item)) {
return total;
}

// Keraboost does NOT count toward ₹999
if (isKeraboost(item)) {
return total;
}

// Bundles DO count toward ₹999
return total + (item.original_line_price || item.final_line_price);

}, 0) / 100;


// ==========================================
// DISCOUNT-ELIGIBLE SUBTOTAL
//
// We do NOT hardcode Keraboost.
// If Shopify has a discount on the item,
// it is considered eligible.
// ==========================================

let discountSubtotal = regularSubtotal;

const discountedItems = cart.items.filter(item => {

    // Free gift does not count
    if (item.variant_id == DD.FREE_GIFT_VARIANT) {
        return false;
    }

    // Bundles do not count
if (isBundle(item)) {
return false;
}

// Gift Cards do not count
if (isGiftCard(item)) {
return false;
}

// Keraboost does NOT count
// toward ₹501 / ₹700 discount progress
if (isKeraboost(item)) {
return false;
}

// Shopify discount information
return item.discounts &&
   Array.isArray(item.discounts) &&
   item.discounts.length > 0;

});


// If Shopify has actually applied a discount,
// use those discounted products for the
// 10% / 15% milestone calculation.

if (discountedItems.length > 0) {

    discountSubtotal = discountedItems.reduce((total, item) => {

        return total +
            (item.original_line_price || item.final_line_price);

    }, 0) / 100;

} else if (regularSubtotal >= DD.GOAL_10) {

    // No applicable discount = no 10% / 15%
    discountSubtotal = 0;

}


// ==========================================
// RESET ALL ICONS FIRST
// ==========================================

document.querySelectorAll(".dd-progress-item").forEach(function(item){

    item.classList.remove("active");

});


// ==========================================
// START ICON
// ==========================================

if(subtotal >= 1){

    document
        .querySelector(".dd-progress-item:nth-child(1)")
        ?.classList.add("active");

}


// ==========================================
// FREE SHIPPING
// ==========================================

if(subtotal >= DD.GOAL_SHIPPING){

    document
        .querySelector(".dd-progress-item:nth-child(2)")
        ?.classList.add("active");

}


// ==========================================
// 10% OFF
//
// ONLY active when discount is actually
// applicable.
// ==========================================

if(discountSubtotal >= DD.GOAL_10){

    document
        .querySelector(".dd-progress-item:nth-child(3)")
        ?.classList.add("active");

    activateMilestone("501");

}


// ==========================================
// 15% OFF
//
// ONLY active when discount is actually
// applicable.
// ==========================================

if(discountSubtotal >= DD.GOAL_15){

    document
        .querySelector(".dd-progress-item:nth-child(4)")
        ?.classList.add("active");

    activateMilestone("700");

}


// ==========================================
// FREE GIFT
//
// This remains based on the normal subtotal.
// ==========================================


// change for the gift card cart2.0
// if(subtotal >= DD.GOAL_GIFT){
// change for the gift card  cart2.0



if(freeGiftSubtotal >= DD.GOAL_GIFT){
    document
        .querySelector(".dd-progress-item:nth-child(5)")
        ?.classList.add("active");

    activateMilestone("999");

}

}



/*==================================================
DIPESH CODE START - CART2.0
KERA BOOST FREEBIE EXCLUSION
==================================================*/

function isKeraboost(item) {

const title = (item.title || "").toLowerCase().trim();
const handle = (item.handle || "").toLowerCase().trim();

return (
    title.includes("keraboost") ||
    handle.includes("keraboost")
);

}

/*==================================================
DIPESH CODE END - CART2.0
==================================================*/

/*==================================================
DIPESH CODE START - CART2.0
AUTO FREE GIFT ENGINE
==================================================*/

async function giftEngine(cart){

    /*
    ==================================================
    DD FREEBIE SAFETY ENGINE
    ==================================================

    RULES:

    1. Freebie NEVER counts toward ₹999.
    2. Keraboost NEVER qualifies for ₹999.
    3. Gift Card NEVER qualifies for ₹999.
    4. Bundle DOES qualify for ₹999.
    5. Normal products qualify for ₹999.
    6. Below ₹999 = ZERO FREEBIES.
    7. ₹999+ = EXACTLY ONE FREEBIE.
    8. Freebie quantity is ALWAYS exactly 1.
    9. Freebie can NEVER be alone in the cart
       (needs at least one real product / bundle).
    ==================================================
    */


    /*==================================================
    SAFETY LOCK
    ==================================================*/

    if(window.DD_GIFT_ENGINE_RUNNING){

        console.log(
            "DD FREEBIE: Gift engine already running."
        );

        return false;

    }

    window.DD_GIFT_ENGINE_RUNNING = true;


    try{

        /*==================================================
        BASIC CART SAFETY
        ==================================================*/

        if(
            !cart ||
            !Array.isArray(cart.items)
        ){

            console.warn(
                "DD FREEBIE: Invalid cart object."
            );

            return false;

        }


        /*==================================================
        CART DRAWER SECTION
        ==================================================*/

        const drawerElement =
            document.querySelector("cart-drawer");


        const SECTION_ID =
            drawerElement
                ? drawerElement.getAttribute(
                    "data-section-id"
                )
                : null;


        /*==================================================
        CALCULATE ₹999 QUALIFYING SUBTOTAL
        ==================================================

        COUNTS:
        ✓ Normal products
        ✓ Bundles

        DOES NOT COUNT:
        ✕ Freebie
        ✕ Keraboost
        ✕ Gift Card
        ==================================================*/

        const qualifyingSubtotal =
            cart.items.reduce(
                function(total,item){

                    if(!item){

                        return total;

                    }


                    /*
                    ------------------------------------------
                    FREEBIE
                    ------------------------------------------
                    */

                    if(
                        item.variant_id ==
                        DD.FREE_GIFT_VARIANT
                    ){

                        return total;

                    }


                    /*
                    ------------------------------------------
                    KERABOOST
                    ------------------------------------------
                    */

                    if(
                        typeof isKeraboost === "function" &&
                        isKeraboost(item)
                    ){

                        return total;

                    }


                    /*
                    ------------------------------------------
                    GIFT CARD
                    ------------------------------------------
                    */

                    if(
                        typeof isGiftCard === "function" &&
                        isGiftCard(item)
                    ){

                        return total;

                    }


                    /*
                    ------------------------------------------
                    NORMAL PRODUCT + BUNDLE
                    BOTH COUNT
                    ------------------------------------------
                    */

                    return total + (
                        item.original_line_price ||
                        item.final_line_price ||
                        0
                    );

                },
                0
            ) / 100;


        /*==================================================
        AT LEAST ONE REAL PRODUCT / BUNDLE IN CART

        Freebie alone, Gift Card alone, Keraboost alone,
        or any mix of only those = NOT eligible.
        ==================================================*/

        const hasRealProduct =
            cart.items.some(
                function(item){

                    if(!item){

                        return false;

                    }

                    if(
                        item.variant_id ==
                        DD.FREE_GIFT_VARIANT
                    ){

                        return false;

                    }

                    if(
                        typeof isKeraboost === "function" &&
                        isKeraboost(item)
                    ){

                        return false;

                    }

                    if(
                        typeof isGiftCard === "function" &&
                        isGiftCard(item)
                    ){

                        return false;

                    }

                    return true;

                }
            );


        /*==================================================
        FINAL ELIGIBILITY
        ==================================================*/

        const giftEligible =
            hasRealProduct &&
            qualifyingSubtotal >=
            DD.GOAL_GIFT;


        /*==================================================
        FIND EVERY FREEBIE
        ==================================================*/

        const giftItems =
            cart.items.filter(
                function(item){

                    return (
                        item &&
                        item.variant_id ==
                        DD.FREE_GIFT_VARIANT
                    );

                }
            );


        const hasGift =
            giftItems.length > 0;


        console.log(
            "DD FREEBIE CHECK:",
            {
                qualifyingSubtotal:
                    qualifyingSubtotal,

                hasRealProduct:
                    hasRealProduct,

                goal:
                    DD.GOAL_GIFT,

                freebieCount:
                    giftItems.length
            }
        );


        /*==================================================
        CASE 1
        NOT ELIGIBLE (BELOW ₹999, OR FREEBIE ALONE,
        OR ONLY GIFT CARD / KERABOOST)
        ==================================================

        IMPORTANT:

        Even if somebody manually added the Freebie,
        REMOVE IT.

        This is the part that fixes the situation
        where only "Moiz Freebie" is sitting in cart.
        ==================================================*/

        if(
            !giftEligible
        ){

            if(!hasGift){

                return false;

            }


            console.log(
                "DD FREEBIE: Cart not eligible. Removing freebie."
            );


            let updatedCart = cart;


            /*
            ------------------------------------------
            REMOVE EVERY FREEBIE LINE
            ------------------------------------------
            */

            for(
                const giftItem of giftItems
            ){

                if(!giftItem.key){

                    continue;

                }


                const response =
                    await fetch(
                        "/cart/change.js",
                        {
                            method:"POST",

                            headers:{
                                "Content-Type":
                                    "application/json",

                                "Accept":
                                    "application/json"
                            },

                            body:
                                JSON.stringify({
                                    id:
                                        giftItem.key,

                                    quantity:0
                                })
                        }
                    );


                if(!response.ok){

                    throw new Error(
                        "DD FREEBIE: Could not remove freebie."
                    );

                }


                updatedCart =
                    await response.json();

            }


            /*
            ------------------------------------------
            REFRESH CART DRAWER
            ------------------------------------------
            */

            const drawer =
                document.querySelector(
                    "cart-drawer"
                );


            if(
                drawer &&
                typeof drawer.onCartRefresh ===
                "function"
            ){

                await drawer.onCartRefresh({
                    detail:{
                        open:true
                    }
                });

            }


            return {
                changed:true,

                cart:
                    updatedCart,

                popup:{
                    title:
                        "Free Gift Removed",

                    description:
                        "Add qualifying products worth ₹999 or more to unlock the free gift.",

                    celebrate:false
                }
            };

        }


        /*==================================================
        CASE 2
        ELIGIBLE (₹999+ AND REAL PRODUCT) BUT NO FREEBIE
        ==================================================

        Add EXACTLY ONE freebie.
        ==================================================*/

        if(
            giftEligible &&
            !hasGift
        ){

            console.log(
                "DD FREEBIE: ₹999 reached. Adding freebie."
            );


            const requestBody = {

                items:[
                    {
                        id:
                            DD.FREE_GIFT_VARIANT,

                        quantity:1
                    }
                ]

            };


            /*
            ------------------------------------------
            SECTION RENDERING
            ------------------------------------------
            */

            if(SECTION_ID){

                requestBody.sections =
                    [SECTION_ID];

                requestBody.sections_url =
                    window.location.pathname;

            }

            window.DD_GIFT_ENGINE_ADDING = true;

let response;

try{

    response = await fetch(
        "/cart/add.js",
        {
            method:"POST",

            headers:{
                "Content-Type":
                    "application/json",

                "Accept":
                    "application/json"
            },

            body:
                JSON.stringify(
                    requestBody
                )
        }
    );

}finally{

    window.DD_GIFT_ENGINE_ADDING = false;

}


            if(!response.ok){

                throw new Error(
                    "DD FREEBIE: Could not add freebie."
                );

            }


            const updatedCart =
                await response.json();


            /*
            ------------------------------------------
            REFRESH CART DRAWER
            ------------------------------------------
            */

            const drawer =
                document.querySelector(
                    "cart-drawer"
                );


            if(
                drawer &&
                typeof drawer.onCartRefresh ===
                "function"
            ){

                await drawer.onCartRefresh({
                    detail:{
                        open:true
                    }
                });

            }


            await new Promise(
                function(resolve){

                    setTimeout(
                        resolve,
                        300
                    );

                }
            );


            return {

                changed:true,

                cart:
                    updatedCart,

                popup:{

                    title:
                        "🎁 Hurray! Freebie Added",

                    description:
                        "Your free gift has been unlocked.",

                    celebrate:true

                }

            };

        }


        /*==================================================
        CASE 3
        ELIGIBLE AND FREEBIE EXISTS
        ==================================================

        Keep EXACTLY ONE freebie.
        ==================================================*/

        if(
            giftEligible &&
            hasGift
        ){

            /*
            ------------------------------------------
            MORE THAN ONE FREEBIE LINE
            ------------------------------------------
            */

            if(giftItems.length > 1){

                console.warn(
                    "DD FREEBIE: Duplicate freebies detected."
                );


                const duplicateGiftItems =
                    giftItems.slice(1);


                let updatedCart =
                    cart;


                for(
                    const duplicateGift of
                    duplicateGiftItems
                ){

                    if(!duplicateGift.key){

                        continue;

                    }


                    const response =
                        await fetch(
                            "/cart/change.js",
                            {
                                method:"POST",

                                headers:{
                                    "Content-Type":
                                        "application/json",

                                    "Accept":
                                        "application/json"
                                },

                                body:
                                    JSON.stringify({

                                        id:
                                            duplicateGift.key,

                                        quantity:0

                                    })
                            }
                        );


                    if(!response.ok){

                        throw new Error(
                            "DD FREEBIE: Duplicate removal failed."
                        );

                    }


                    updatedCart =
                        await response.json();

                }


                /*
                ------------------------------------------
                FIND REMAINING FREEBIE
                ------------------------------------------
                */

                const remainingGift =
                    updatedCart.items.find(
                        function(item){

                            return (
                                item.variant_id ==
                                DD.FREE_GIFT_VARIANT
                            );

                        }
                    );


                /*
                ------------------------------------------
                FORCE QUANTITY = 1
                ------------------------------------------
                */

                if(
                    remainingGift &&
                    remainingGift.quantity !== 1
                ){

                    const response =
                        await fetch(
                            "/cart/change.js",
                            {
                                method:"POST",

                                headers:{
                                    "Content-Type":
                                        "application/json",

                                    "Accept":
                                        "application/json"
                                },

                                body:
                                    JSON.stringify({

                                        id:
                                            remainingGift.key,

                                        quantity:1

                                    })
                            }
                        );


                    if(!response.ok){

                        throw new Error(
                            "DD FREEBIE: Quantity correction failed."
                        );

                    }


                    updatedCart =
                        await response.json();

                }


                return {

                    changed:true,

                    cart:
                        updatedCart

                };

            }


            /*
            ------------------------------------------
            EXACTLY ONE FREEBIE
            ------------------------------------------
            */

            const giftItem =
                giftItems[0];


            if(
                giftItem.quantity !== 1
            ){

                console.warn(
                    "DD FREEBIE: Correcting freebie quantity."
                );


                const response =
                    await fetch(
                        "/cart/change.js",
                        {
                            method:"POST",

                            headers:{
                                "Content-Type":
                                    "application/json",

                                "Accept":
                                    "application/json"
                            },

                            body:
                                JSON.stringify({

                                    id:
                                        giftItem.key,

                                    quantity:1

                                })
                        }
                    );


                if(!response.ok){

                    throw new Error(
                        "DD FREEBIE: Quantity correction failed."
                    );

                }


                const updatedCart =
                    await response.json();


                return {

                    changed:true,

                    cart:
                        updatedCart

                };

            }


            /*
            ------------------------------------------
            EVERYTHING IS CORRECT
            ------------------------------------------
            */

            return false;

        }


        return false;


    }

    catch(error){

        console.error(
            "DD FREEBIE ENGINE ERROR:",
            error
        );

        return false;

    }

    finally{

        /*
        ------------------------------------------
        ALWAYS RELEASE LOCK
        ------------------------------------------
        */

        window.DD_GIFT_ENGINE_RUNNING =
            false;

    }

}


/*==================================================
DIPESH CODE END - CART2.0
==================================================*/

/*==================================================
POPUP + CONFETTI + COUNTDOWN
==================================================*/

function showPopup(title, description, showCelebration = true) {

const overlay = document.querySelector(".dd-popup-overlay");
if (!overlay) return;

const icon = overlay.querySelector(".dd-popup-icon");
const heading = overlay.querySelector("h2");
const message = overlay.querySelector(".dd-popup-message");
const saving = overlay.querySelector(".dd-popup-saving");

if (icon) {
icon.style.display = showCelebration ? "" : "none";
}

if (heading) {
heading.style.display = showCelebration ? "" : "none";
}
message.innerHTML = title;
saving.innerHTML = description;

clearTimeout(window.ddPopupTimer);

overlay.classList.remove("show");
void overlay.offsetWidth;
overlay.classList.add("show");

window.ddPopupTimer = setTimeout(function () {
    overlay.classList.remove("show");
}, 3000);
}

function playConfetti(){

    const container = document.querySelector(".dd-cart-wrapper");
    if(!container) return;

    const rect = container.getBoundingClientRect();

    const colors = [
        "#B37941",
        "#FFD54F",
        "#66BB6A",
        "#29B6F6",
        "#EF5350",
        "#FF6B6B",
        "#7C4DFF",
        "#26A69A"
    ];

    for(let i=0;i<80;i++){

        const c = document.createElement("div");
        c.className = "dd-confetti no-empty";

        c.style.left = Math.random() * rect.width + "px";
        c.style.top = "20px";

        c.style.background =
            colors[Math.floor(Math.random()*colors.length)];

        c.style.transform =
            `rotate(${Math.random()*360}deg)`;

        c.style.animationDelay =
            (Math.random()*0.4)+"s";

        c.style.animationDuration =
            (1.8 + Math.random())+"s";

        container.appendChild(c);

        c.addEventListener("animationend",function(){
            c.remove();
        });

    }

}

/*==================================================
COUNTDOWN (change the timer for the cart from here )
==================================================*/

function initCountdown(){

    DD.TIMER_END = new Date();

    DD.TIMER_END.setDate(DD.TIMER_END.getDate()+1);

    DD.TIMER_END.setHours(1);

    DD.TIMER_END.setMinutes(59);

    DD.TIMER_END.setSeconds(59);

    updateCountdown();

    setInterval(updateCountdown,1000);

}

function updateCountdown(){

    const now = new Date();

    let diff = DD.TIMER_END - now;

    if(diff < 0){

        diff = 0;

    }

    const days =
    Math.floor(diff/(1000*60*60*24));

    const hours =
    Math.floor((diff%(1000*60*60*24))/(1000*60*60));

    const minutes =
    Math.floor((diff%(1000*60*60))/(1000*60));

    const seconds =
    Math.floor((diff%(1000*60))/1000);

    const timer = document.getElementById("ddTimer");

if(timer){

    if(days > 0){

        timer.textContent =
`${String(days).padStart(2,"0")}D ${String(hours).padStart(2,"0")}:${String(minutes).padStart(2,"0")}:${String(seconds).padStart(2,"0")}`;

    }else{

        timer.textContent =
            `${String(hours).padStart(2,"0")}:${String(minutes).padStart(2,"0")}:${String(seconds).padStart(2,"0")}`;

    }

}
}

/*==================================================
ACCORDIONS
==================================================*/

function bindAccordions(){

    document.querySelectorAll(".dd-coupon-head").forEach(function(item){

        item.addEventListener("click",function(){

            this.parentElement.classList.toggle("active");

        });

    });

    

}



/*=============================
BOTTOM SUMMARY
=============================*/


document.addEventListener("click",function(e){

    const wrapper = document.querySelector(".dd-bottom-wrapper");

    if(!wrapper) return;

    if(e.target.closest(".dd-footer-left, .dd-bill-head")){

        wrapper.classList.toggle("open");

        return;

    }

    if(e.target.closest(".dd-bill-close")){

        wrapper.classList.remove("open");

        return;

    }

});





function checkMilestones(cart){

/*==================================================
SHIPPING SUBTOTAL

Keraboost COUNT
Gift Card COUNT
Bundle does NOT count
Free gift does NOT count
==================================================*/

const subtotal = cart.items.reduce(
    (total, item) => {

        if (
            item.variant_id ==
            DD.FREE_GIFT_VARIANT
        ) {
            return total;
        }

        if (isBundle(item)) {
            return total;
        }

        return total + (
            item.original_line_price ||
            item.final_line_price
        );

    },
    0
) / 100;


/*==================================================
REGULAR DISCOUNT SUBTOTAL

Keraboost does NOT count
Gift Card does NOT count
Bundle does NOT count
==================================================*/

const regularSubtotal = cart.items.reduce(
    (total, item) => {

        if (
            item.variant_id ==
            DD.FREE_GIFT_VARIANT
        ) {
            return total;
        }

        if (isGiftCard(item)) {
            return total;
        }

        if (isBundle(item)) {
            return total;
        }

        if (isKeraboost(item)) {
            return total;
        }

        return total + (
            item.original_line_price ||
            item.final_line_price
        );

    },
    0
) / 100;


/*==================================================
₹999 FREE GIFT SUBTOTAL

Keraboost does NOT count
Gift Card does NOT count
Bundle DOES count
==================================================*/

const freeGiftSubtotal = cart.items.reduce(
    (total, item) => {

        if (
            item.variant_id ==
            DD.FREE_GIFT_VARIANT
        ) {
            return total;
        }

        if (isGiftCard(item)) {
            return total;
        }

        if (isKeraboost(item)) {
            return total;
        }

        return total + (
            item.original_line_price ||
            item.final_line_price
        );

    },
    0
) / 100;


/*==================================================
ACTUALLY DISCOUNTED PRODUCTS
==================================================*/

let discountSubtotal = regularSubtotal;


const discountedItems = cart.items.filter(
    item => {

        if (
            item.variant_id ==
            DD.FREE_GIFT_VARIANT
        ) {
            return false;
        }

        if (isBundle(item)) {
            return false;
        }

        if (isGiftCard(item)) {
            return false;
        }

        if (isKeraboost(item)) {
            return false;
        }

        return (
            item.discounts &&
            Array.isArray(item.discounts) &&
            item.discounts.length > 0
        );

    }
);


if (discountedItems.length > 0) {

    discountSubtotal =
        discountedItems.reduce(
            (total, item) => {

                return total + (
                    item.original_line_price ||
                    item.final_line_price
                );

            },
            0
        ) / 100;

}

else if (
    regularSubtotal >= DD.GOAL_10
) {

    /*
     * Normal products have reached ₹501,
     * but Shopify has not actually
     * applied the discount.
     */

    discountSubtotal = 0;

}




const milestones = [

    // ==========================================
    // FREE SHIPPING
    // ==========================================

    {
        key: "shipping",

        reached: subtotal >= DD.GOAL_SHIPPING,

        activate: function(){

            activateTruck();

        },

        deactivate: function(){

            deactivateTruck();

        }
    },


    // ==========================================
    // 10% OFF
    //
    // Uses discountSubtotal
    // ==========================================

    {
        key: "goal501",

        reached: discountSubtotal >= DD.GOAL_10,

        activate: function(){

            activateMilestone("501");
            fireConfetti();

        },

        deactivate: function(){

            deactivateMilestone("501");

        }
    },


    // ==========================================
    // 15% OFF
    //
    // Uses discountSubtotal
    // ==========================================

    {
        key: "goal700",

        reached: discountSubtotal >= DD.GOAL_15,

        activate: function(){

            activateMilestone("700");
            fireConfetti();

        },

        deactivate: function(){

            deactivateMilestone("700");

        }
    },


    // ==========================================
    // FREE GIFT
    //
    // Still uses normal subtotal
    // ==========================================

    {
        key: "goal999",

        reached: freeGiftSubtotal >= DD.GOAL_GIFT,

        activate: function(){

            activateMilestone("999");
            fireConfetti();

        },

        deactivate: function(){

            deactivateMilestone("999");

        }
    }

];


// ==========================================
// APPLY MILESTONE STATES
// ==========================================

milestones.forEach(function(item){

    if(item.reached){

        if(!DD.MILESTONE_STATE[item.key]){

            DD.MILESTONE_STATE[item.key] = true;

            item.activate();

        }

    } else {

        DD.MILESTONE_STATE[item.key] = false;

        item.deactivate();

    }

});

}

let ddTruckLoop=null;

function activateTruck(){

    const truck=document.querySelector(".dd-truck-icon");

    if(!truck) return;

    animateTruck();

    clearInterval(ddTruckLoop);

    ddTruckLoop=setInterval(function(){

        animateTruck();

    },6500);

}

function deactivateTruck(){

    clearInterval(ddTruckLoop);

    const truck=document.querySelector(".dd-truck-icon");

    if(!truck) return;

    

    truck.classList.remove("dd-truck-move");

}

function animateTruck(){

    const truck=document.querySelector(".dd-truck-icon");

    if(!truck) return;

    truck.classList.remove("dd-truck-move");

    void truck.offsetWidth;

    truck.classList.add("dd-truck-move");

}

function resetTruck(){

    const truck = document.querySelector(".dd-truck-icon");

    if(!truck) return;

    truck.classList.remove("dd-truck-move");

}

function activateMilestone(type){

    const icons = {

        "501": {
            selector: ".dd-goal501-icon",
            src: "https://cdn.shopify.com/s/files/1/0827/3769/2973/files/10-percent-off-circle.svg?v=1784699565"
        },

        "700": {
            selector: ".dd-goal700-icon",
            src: "https://cdn.shopify.com/s/files/1/0827/3769/2973/files/15-percent-off-circle.svg?v=1784699726"
        },

        "999": {
            selector: ".dd-goal999-icon",
            src: "https://cdn.shopify.com/s/files/1/0827/3769/2973/files/freebie-gift-red.svg?v=1784722388"
        }

    };

    const item = icons[type];

    if(!item) return;

    const img = document.querySelector(item.selector);

    if(!img) return;

    img.src = item.src;

    img.classList.remove("dd-bounce");
    void img.offsetWidth;
    img.classList.add("dd-bounce");

}

function deactivateMilestone(type){

    const icons = {

        "501": {
            selector: ".dd-goal501-icon",
            src: "https://cdn.shopify.com/s/files/1/0827/3769/2973/files/10-percent-off-circle-gray.svg?v=1784700912"
        },

        "700": {
            selector: ".dd-goal700-icon",
            src: "https://cdn.shopify.com/s/files/1/0827/3769/2973/files/15-percent-off-circle-gray.svg?v=1784700911"
        },

        "999": {
            selector: ".dd-goal999-icon",
            src: "https://cdn.shopify.com/s/files/1/0827/3769/2973/files/freebie-gift-gray.svg?v=1784722388"
        }

    };

    const item = icons[type];

    if(!item) return;

    const img = document.querySelector(item.selector);

    if(!img) return;

    img.src = item.src;

    img.classList.remove("dd-bounce");
    void img.offsetWidth;

}

function fireConfetti(){

    playConfetti();

}



/*==================================================
UPSELL PRODUCTS
==================================================*/

function ddUpsellEscapeHtml(value) {

    return String(value ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");

}


function ddUpsellIsExcludedProduct(product) {

    if (!product) return true;

    const title = (product.title || "").toLowerCase().trim();
    const type = (
    product.product_type ||
    product.type ||
    ""
).toLowerCase().trim();
    const handle = (product.handle || "").toLowerCase().trim();

    const tags = Array.isArray(product.tags)
        ? product.tags.map(tag =>
            String(tag).toLowerCase().trim()
        )
        : [];


    /* Exclude bundle / combo / gift set */

    if (
        type === "combos" ||
        type.includes("combo") ||
        type.includes("bundle") ||
        type.includes("gift set") ||
        type.includes("giftset")
    ) {
        return true;
    }


    if (
        title.includes("bundle") ||
        title.includes("combo") ||
        title.includes("gift set") ||
        title.includes("giftset")
    ) {
        return true;
    }


    if (
        handle.includes("bundle") ||
        handle.includes("combo") ||
        handle.includes("gift-set") ||
        handle.includes("giftset")
    ) {
        return true;
    }


    /* Exclude products tagged as bundle/combo */

    if (
        tags.includes("bundle") ||
        tags.includes("bundles") ||
        tags.includes("combo") ||
        tags.includes("combos") ||
        tags.includes("gift-set") ||
        tags.includes("gift set")
    ) {
        return true;
    }


    /* Exclude bundle SKU */

    const variants = Array.isArray(product.variants)
        ? product.variants
        : [];


    if (
        variants.some(variant =>
            String(variant.sku || "")
                .toLowerCase()
                .trim()
                .startsWith("bundle_")
        )
    ) {
        return true;
    }


    return false;

}

/*==================================================
GET CART PRODUCT BRAND / VENDOR
==================================================*/

/*==================================================
GET PRODUCT BRAND
==================================================*/

function ddUpsellGetBrand(product) {

    if (!product) return "";

    const title = String(
        product.title ||
        product.product_title ||
        ""
    )
        .toLowerCase()
        .trim();

    const handle = String(
        product.handle ||
        ""
    )
        .toLowerCase()
        .trim();

    const vendor = String(
        product.vendor ||
        product.product_vendor ||
        ""
    )
        .toLowerCase()
        .trim();


    /*==================================================
    MOIZ
    ==================================================*/

    if (
        title.includes("moiz") ||
        handle.includes("moiz")
    ) {
        return "moiz";
    }


    /*==================================================
    SANOSAN
    ==================================================*/

    if (
        title.includes("sanosan") ||
        handle.includes("sanosan")
    ) {
        return "sanosan";
    }


    /*==================================================
    SEBONAC
    ==================================================*/

    if (
        title.includes("sebonac") ||
        handle.includes("sebonac")
    ) {
        return "sebonac";
    }


    /*==================================================
    KERABOOST
    ==================================================*/

    if (
        title.includes("keraboost") ||
        handle.includes("keraboost")
    ) {
        return "keraboost";
    }


    /*==================================================
    FALLBACK TO VENDOR
    ==================================================*/

    return vendor;

}


async function loadUpsellProducts(cart) {

    DD._upsellRequest = (DD._upsellRequest || 0) + 1;
    const upsellRequest = DD._upsellRequest;

    const slider = document.querySelector(".dd-upsell-track");

    if (!slider) return;


    /*==================================================
    CLEAR OLD RECOMMENDATIONS
    ==================================================*/

    slider.innerHTML = "";


    if (
        !cart ||
        !Array.isArray(cart.items) ||
        cart.items.length === 0
    ) {
        return;
    }


    /*==================================================
    ONLY REAL PRODUCTS CAN GENERATE RELATED UPSELLS

    Sanosan  → Sanosan recommendations
    Moiz     → Moiz recommendations
    Keraboost → Keraboost recommendations

    Multiple products:
    Merge the recommendation pools together.

    Free Gift / Bundle / Gift Card:
    Cannot generate recommendations.
    ==================================================*/

    const eligibleCartItems = cart.items.filter(item => {

        if (!item) return false;


        /* Free gift cannot generate recommendations */

        if (
            item.variant_id == DD.FREE_GIFT_VARIANT
        ) {
            return false;
        }


        /* Bundle cannot generate recommendations */

        if (
            isBundle(item)
        ) {
            return false;
        }


        /* Gift Card cannot generate recommendations */

        if (
            typeof isGiftCard === "function" &&
            isGiftCard(item)
        ) {
            return false;
        }


        /* Product must have product ID */

        if (
            !item.product_id
        ) {
            return false;
        }


        return true;

    });


   /*==================================================
    MOIZ FALLBACK CART

    If the cart contains ONLY:
    - Bundle
    - Gift Card
    - Free Gift

    Then use Moiz as the fallback upsell.

    IMPORTANT:
    If a real branded product exists,
    the normal same-brand upsell system continues.
    ==================================================*/

    
const hasSebonacInCart = eligibleCartItems.some(item => {
    return ddUpsellGetBrand(item) === "sebonac";
});

const hasMoizFallbackCart =
    eligibleCartItems.length === 0 ||
    hasSebonacInCart;



    /*==================================================
    UPSELL TITLE
    ==================================================*/

    const eligibleSubtotal =
        cart.items.reduce((total, item) => {

            if (
                item.variant_id ==
                DD.FREE_GIFT_VARIANT
            ) {
                return total;
            }

            if (
                isBundle(item)
            ) {
                return total;
            }

            if (
                typeof isGiftCard === "function" &&
                isGiftCard(item)
            ) {
                return total;
            }

            return total + (
                item.original_line_price ||
                item.final_line_price
            );

        }, 0) / 100;


    const upsellHeading =
        document.querySelector(".dd-upsell-heading");


    if (upsellHeading) {

        if (eligibleSubtotal < DD.GOAL_SHIPPING) {

            upsellHeading.innerHTML =
                "You may also like";

        }
        else if (eligibleSubtotal < DD.GOAL_10) {

            upsellHeading.innerHTML =
                "Complete your routine";

        }
        else {

            upsellHeading.innerHTML =
                "You may also like";

        }

    }


    /*==================================================
    PRODUCTS ALREADY IN CART
    ==================================================*/

    const cartProductIds = new Set();

    cart.items.forEach(item => {

        if (
            item &&
            item.product_id
        ) {

            cartProductIds.add(
                Number(item.product_id)
            );

        }

    });


    /*==================================================
    PRODUCTS THAT ARE BUNDLES IN CART

    Keep this protection so bundle products
    can never appear in upsells.
    ==================================================*/

    const cartBundleProductIds = new Set();

    cart.items.forEach(item => {

        if (
            !item ||
            !item.product_id
        ) {
            return;
        }


        if (
            isBundle(item)
        ) {

            cartBundleProductIds.add(
                Number(item.product_id)
            );

        }

    });


    /*==================================================
    GET RECOMMENDATIONS FROM EVERY REAL CART PRODUCT

    IMPORTANT:

    If cart has:

    Sanosan
        → fetch Sanosan recommendations

    Moiz
        → fetch Moiz recommendations

    Keraboost
        → fetch Keraboost recommendations

    Moiz + Sanosan
        → fetch BOTH
        → merge BOTH pools

    Moiz + Sanosan + Keraboost
        → fetch ALL THREE
        → merge ALL THREE pools
    ==================================================*/

    const recommendationMap = new Map();


for (
    const cartItem
    of eligibleCartItems
) {

    const productId =
        Number(cartItem.product_id);


    if (!productId) {
        continue;
    }


    /*==================================================
    SOURCE PRODUCT BRAND

    Example:

    Moiz product → moiz
    Sanosan product → sanosan
    Sebonac product → sebonac
    ==================================================*/

    const sourceBrand =
        ddUpsellGetBrand(cartItem);


    console.log(
        "DD UPSELL SOURCE:",
        cartItem.title,
        "BRAND:",
        sourceBrand
    );




        try {

            /*
             * Shopify's recommendation API uses the
             * current cart product as the source.
             */

            const response = await fetch(
                `/recommendations/products.json?product_id=${productId}&limit=20`
            );


            if (!response.ok) {
                continue;
            }


            const data =
                await response.json();


            if (
                !data ||
                !Array.isArray(data.products) ||
                data.products.length === 0
            ) {
                continue;
            }


            /*==================================================
            ADD THIS CART PRODUCT'S RECOMMENDATIONS
            ==================================================*/

            data.products.forEach(product => {

                if (
                    !product ||
                    !product.id
                ) {
                    return;
                }


                const recommendationId =
                    Number(product.id);


                /*==================================================
                SAME BRAND ONLY

                If cart product is Moiz:
                    → only Moiz recommendations

                If cart product is Sanosan:
                    → only Sanosan recommendations

                If cart product is Sebonac:
                    → only Sebonac recommendations

                When multiple brands are in cart:
                    → each cart product gets its own brand pool
                    → all pools are merged below
                ==================================================*/

             

                /*==================================================
                STRICT SAME-BRAND FILTER
                ==================================================*/

                const recommendationBrand =
                    ddUpsellGetBrand(product);


                /*
                * Cart product must have a known brand.
                */

                if (!sourceBrand) {
                    return;
                }


                /*
                * Recommendation must have a known brand.
                */

                if (!recommendationBrand) {
                    return;
                }


                /*
                * ONLY SHOW SAME BRAND
                *
                * Sebonac → Sebonac only
                * Moiz → Moiz only
                * Sanosan → Sanosan only
                * Keraboost → Keraboost only
                */

                if (recommendationBrand !== sourceBrand) {
                    return;
                }


                /*==================================================
                ALREADY IN CART
                ==================================================*/

                if (
                    cartProductIds.has(
                        recommendationId
                    )
                ) {
                    return;
                }


                /*==================================================
                NEVER RECOMMEND A BUNDLE ALREADY IN CART
                ==================================================*/

                if (
                    cartBundleProductIds.has(
                        recommendationId
                    )
                ) {
                    return;
                }


                /*==================================================
                DON'T RECOMMEND THE SOURCE PRODUCT
                ==================================================*/

                if (
                    recommendationId === productId
                ) {
                    return;
                }


                /*==================================================
                REMOVE COMBOS / BUNDLES / GIFT SETS
                ==================================================*/

                if (
                    ddUpsellIsExcludedProduct(product)
                ) {
                    return;
                }


                /*==================================================
                FIND USABLE VARIANT
                ==================================================*/

                const variants =
                    Array.isArray(product.variants)
                        ? product.variants
                        : [];


                const selectedVariant =
                    variants.find(
                        variant =>
                            variant &&
                            variant.available
                    ) ||
                    variants.find(
                        variant =>
                            variant
                    ) ||
                    null;


                if (
                    !selectedVariant ||
                    !selectedVariant.id
                ) {
                    return;
                }


                /*==================================================
                DEDUPE

                If Moiz and Sanosan both recommend
                the same product, show it only once.
                ==================================================*/

                if (
                    !recommendationMap.has(
                        recommendationId
                    )
                ) {

                    recommendationMap.set(
                        recommendationId,
                        {
                            product: product,
                            variant: selectedVariant
                        }
                    );

                }

            });


        }
        catch (error) {

            console.warn(
                "DD Upsell recommendation failed:",
                productId,
                error
            );

        }

    }


    /*==================================================
    FINAL RELATED PRODUCT FILTER
    ==================================================*/

    let recommendations =
        Array.from(
            recommendationMap.values()
        )
        .filter(entry => {

            if (
                !entry ||
                !entry.product ||
                !entry.variant
            ) {
                return false;
            }


            const product =
                entry.product;


            /*==================================================
            PRODUCT ALREADY IN CART
            ==================================================*/

            if (
                cartProductIds.has(
                    Number(product.id)
                )
            ) {
                return false;
            }


            /*==================================================
            FINAL BUNDLE / COMBO / GIFT SET PROTECTION
            ==================================================*/

            if (
                ddUpsellIsExcludedProduct(
                    product
                )
            ) {
                return false;
            }


            /*==================================================
            VARIANT UNAVAILABLE
            ==================================================*/

            if (
                entry.variant.available === false
            ) {
                return false;
            }


            return true;

        })
        .slice(0, 20);

        /*==================================================
MOIZ FALLBACK
==================================================

Use Moiz ONLY when there is no real product
available to generate normal upsells.

Examples:

Bundle only
    → Moiz

Gift Card only
    → Moiz

Free Gift only
    → Moiz

Bundle + Gift Card
    → Moiz

Bundle + Free Gift
    → Moiz

If Moiz / Sanosan / Sebonac / Keraboost
is actually in the cart:
    → normal same-brand system is used.
==================================================*/

if (
    hasMoizFallbackCart &&
    recommendations.length === 0
) {

    console.log(
        "DD UPSELL: No real product in cart. Loading Moiz fallback."
    );


    try {

        const moizResponse = await fetch(
            "/search/suggest.json?q=Moiz&resources[type]=product&resources[limit]=8"
        );


        if (moizResponse.ok) {

            const moizData =
                await moizResponse.json();


            const moizProducts =
                moizData &&
                moizData.resources &&
                moizData.resources.results &&
                Array.isArray(
                    moizData.resources.results.products
                )
                    ? moizData.resources.results.products
                    : [];


            for (
                const product
                of moizProducts
            ) {

                if (
                    !product ||
                    !product.id
                ) {
                    continue;
                }


                const productId =
                    Number(product.id);


                /*==================================
                ALREADY IN CART
                ==================================*/

                if (
                    cartProductIds.has(productId)
                ) {
                    continue;
                }


                /*==================================
                NEVER SHOW BUNDLE / COMBO / GIFT SET
                ==================================*/

                if (
                    ddUpsellIsExcludedProduct(product)
                ) {
                    continue;
                }


                /*==================================
                MAKE SURE IT IS ACTUALLY MOIZ
                ==================================*/

                const moizBrand =
                    ddUpsellGetBrand(product);

                if (
                    moizBrand !== "moiz"
                ) {
                    continue;
                }


                /*==================================
                LOAD FULL PRODUCT DATA
                ==================================*/

                let fullProduct = product;


                try {

                    if (
                        product.handle
                    ) {

                        const productResponse =
                            await fetch(
                                `/products/${encodeURIComponent(product.handle)}.js`
                            );


                        if (
                            productResponse.ok
                        ) {

                            const productData =
                                await productResponse.json();


                            if (
                                productData
                            ) {

                                fullProduct =
                                    productData;

                            }

                        }

                    }

                }

                catch (variantError) {

                    console.warn(
                        "DD UPSELL: Could not load Moiz product details:",
                        product.handle,
                        variantError
                    );

                }


                /*==================================
                MAKE SURE FULL PRODUCT IS MOIZ
                ==================================*/

                if (
                    ddUpsellGetBrand(fullProduct) !== "moiz"
                ) {
                    continue;
                }


                /*==================================
                GET AVAILABLE VARIANT
                ==================================*/

                const variants =
                    Array.isArray(
                        fullProduct.variants
                    )
                        ? fullProduct.variants
                        : [];


                const selectedVariant =
                    variants.find(
                        variant =>
                            variant &&
                            variant.available
                    ) ||
                    variants.find(
                        variant =>
                            variant
                    ) ||
                    null;


                if (
                    !selectedVariant ||
                    !selectedVariant.id
                ) {
                    continue;
                }


                /*==================================
                FINAL SAFETY
                ==================================*/

                if (
                    ddUpsellIsExcludedProduct(
                        fullProduct
                    )
                ) {
                    continue;
                }


                if (
                    cartProductIds.has(
                        Number(fullProduct.id)
                    )
                ) {
                    continue;
                }


                /*==================================
                ADD MOIZ PRODUCT
                ==================================*/

                recommendations.push({

                    product:
                        fullProduct,

                    variant:
                        selectedVariant

                });


                if (
                    recommendations.length >= 8
                ) {
                    break;
                }

            }

        }

    }

    catch (error) {

        console.warn(
            "DD UPSELL: Moiz fallback failed:",
            error
        );

    }

}


    /*==================================================
    NO FALLBACK

    IMPORTANT:

    We intentionally DO NOT search for Moiz here.

    If Sanosan has no recommendations:
        → show nothing from Moiz

    If Moiz has no recommendations:
        → show nothing from Sanosan

    If Keraboost has no recommendations:
        → show nothing from Moiz/Sanosan

    Only recommendations generated by the
    products actually in the cart are allowed.
    ==================================================*/

    if (
        recommendations.length === 0
    ) {

        console.log(
            "DD Upsell: No related products available."
        );

        return;

    }


    /*==================================================
    PREVENT OLD REQUEST FROM OVERWRITING
    NEW CART STATE
    ==================================================*/

    if (
        upsellRequest !== DD._upsellRequest
    ) {
        return;
    }


    /*==================================================
    FINAL LIMIT
    ==================================================*/

    recommendations =
        recommendations.slice(0, 20);


    /*==================================================
    RENDER UPSELL CARDS
    ==================================================*/

    recommendations.forEach(entry => {

        const product =
            entry.product;

        const variant =
            entry.variant;


        const image =
            product.featured_image ||
            (
                Array.isArray(product.images) &&
                product.images.length
                    ? product.images[0]
                    : ""
            );


        const title =
            ddUpsellEscapeHtml(
                product.title ||
                "Product"
            );


        const imageUrl =
            ddUpsellEscapeHtml(
                image || ""
            );


        const variantId =
            ddUpsellEscapeHtml(
                variant.id
            );


        const sellingPrice =
            Number(
                variant.price ??
                product.price ??
                product.price_min ??
                0
            );


        let compareAtPrice =
            Number(
                variant.compare_at_price ??
                product.compare_at_price ??
                0
            );


        if (
            compareAtPrice <= sellingPrice
        ) {
            compareAtPrice = 0;
        }


        slider.insertAdjacentHTML(
            "beforeend",
            `
            <div class="dd-upsell-card">

                <div class="dd-upsell-image">

                    ${
                        imageUrl
                        ?
                        `
                        <img
                            src="${imageUrl}"
                            alt="${title}"
                            loading="lazy"
                        >
                        `
                        :
                        ""
                    }

                </div>


                <div class="dd-upsell-info">

                    <div class="dd-upsell-title">
                        ${title}
                    </div>


                    <div class="dd-upsell-price">

                        <span class="dd-upsell-selling-price">
                            ${formatMoney(Math.round(sellingPrice / 100) * 100)}
                        </span>

                        ${
                            compareAtPrice > 0
                            ?
                            `
                            <span class="dd-upsell-compare-price">
                               ${formatMoney(Math.round(compareAtPrice))}
                            </span>
                            `
                            :
                            ""
                        }

                    </div>


                    <button
                        type="button"
                        class="dd-upsell-btn"
                        data-variant="${variantId}"
                    >
                        Add
                    </button>

                </div>

            </div>
            `
        );

    });

}



// code for the upsell cart2.0 code starts


    /*==================================================
    UPSELL ADD TO CART
    ==================================================*/

    document.addEventListener("click", async function(e){

        const btn = e.target.closest(".dd-upsell-btn");

        if(!btn) return;

        e.preventDefault();
        e.stopPropagation();

        if(btn.disabled) return;

        const variantId = Number(btn.dataset.variant);

        if(!variantId){
            console.error("DD Upsell: Invalid variant ID");
            return;
        }

        const originalText = btn.innerHTML;

        try{

            btn.disabled = true;
            btn.innerHTML = "Adding...";

            const response = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    items: [
                        {
                            id: variantId,
                            quantity: 1
                        }
                    ]
                })
            });

            if(!response.ok){

                const errorText = await response.text();

                console.error(
                    "DD Upsell Add Failed:",
                    response.status,
                    errorText
                );

                throw new Error("Upsell product could not be added");

            }

            await response.json();

            /* Refresh our custom cart */
            await refreshCart();

            /* Tell Shopify/custom cart that cart changed */
            document.dispatchEvent(
                new CustomEvent("cart:refresh", {
                    detail: {
                        open: true
                    }
                })
            );

            const drawer = document.querySelector("cart-drawer");

            if(
                drawer &&
                typeof drawer.onCartRefresh === "function"
            ){

                await drawer.onCartRefresh({
                    detail: {
                        open: true
                    }
                });

            }

        }
        catch(error){

            console.error(
                "DD Upsell Add Error:",
                error
            );

            btn.innerHTML = "Try Again";

            setTimeout(function(){

                if(btn){

                    btn.innerHTML = originalText;
                    btn.disabled = false;

                }

            }, 1500);

            return;

        }

        btn.innerHTML = "Added ✓";

        setTimeout(function(){

            if(btn){

                btn.innerHTML = originalText;
                btn.disabled = false;

            }

        }, 1000);

    });

// code for the upsell cart2.0 code end


    /*==================================================
    UPSELL SLIDER ARROWS
    ==================================================*/

    document.addEventListener("click", function(e){

        const slider = document.querySelector(".dd-upsell-slider");

        if(!slider) return;

        if(e.target.closest(".dd-upsell-next")){

            slider.scrollBy({

                left:120,

                behavior:"smooth"

            });

        }

        if(e.target.closest(".dd-upsell-prev")){

            slider.scrollBy({

                left:-120,

                behavior:"smooth"

            });

        }

    });

/*==================================
GIFT NOTE
==================================*/

function openNoteDrawer(){

    document
        .querySelector(".dd-note-overlay")
        ?.classList.add("show");

}

function closeNoteDrawer(){

    document
        .querySelector(".dd-note-overlay")
        ?.classList.remove("show");

}

async function saveCartNote() {

    const textarea = document.querySelector(".dd-note-text");
    const btn = document.querySelector(".dd-note-save");

    if (!textarea || !btn) return;

    const note = textarea.value.trim();

    btn.disabled = true;
    btn.innerHTML = "Saving...";

    try {

        const response = await fetch("/cart/update.js", {

            method:"POST",

            headers:{
                "Content-Type":"application/json"
            },

            body:JSON.stringify({

                note:note

            })

        });

        if(!response.ok) throw new Error("Failed");

        const notePreview=document.querySelector(".dd-note-preview");

        if(notePreview){

            notePreview.innerHTML=note || "Add a personalised gift note";

        }

        btn.innerHTML="Saved ✓";

        setTimeout(function(){

            closeNoteDrawer();

            btn.innerHTML="Save";

            btn.disabled=false;

        },300);

    }

    catch(err){

        btn.innerHTML="Save";

        btn.disabled=false;

    }

}

const ddNoteTextarea = document.querySelector(".dd-note-text");
const ddNoteCounter = document.querySelector(".dd-note-count");
const ddNoteSaveBtn = document.querySelector(".dd-note-save");

if (ddNoteTextarea && ddNoteCounter && ddNoteSaveBtn) {

    ddNoteTextarea.addEventListener("input", function(){

        ddNoteCounter.textContent = `${ddNoteTextarea.value.length}/160`;

        ddNoteSaveBtn.disabled = ddNoteTextarea.value.trim() === "";

    });

}

document.addEventListener("click",function(e){

    if(e.target.closest(".dd-note-card")){

        openNoteDrawer();

    }

    if(e.target.closest(".dd-note-close")){

        closeNoteDrawer();

    }

    if(e.target.closest(".dd-note-overlay")){

        if(e.target.classList.contains("dd-note-overlay")){

            closeNoteDrawer();

        }

    }

    if(e.target.closest(".dd-note-save")){

        saveCartNote();

    }

});

document.addEventListener("input",function(e){

    if(!e.target.matches(".dd-note-text")) return;

    document.querySelector(".dd-note-count").innerHTML =
        e.target.value.length;

});

/*==================================
COUPON DRAWER
==================================*/

function openCouponDrawer(){

    document
    .querySelector(".dd-coupon-overlay")
    ?.classList.add("active");

    loadCoupons();

}

function closeCouponDrawer(){

    const drawer = document.querySelector(".dd-coupon-overlay");

    if(!drawer) return;

    drawer.classList.remove("active");

}

document.addEventListener("click", function(e){

    if(e.target.closest(".dd-coupon-close")){

        closeCouponDrawer();

    }

});

document.addEventListener("click",function(e){

    if(

        e.target.closest(".coupon-link") ||

        e.target.closest(".coupon-box") ||

        e.target.closest(".dd-coupon-card-open")

    ){

        openCouponDrawer();

    }

});


async function loadCoupons(){

    const cart = await fetch("/cart.js").then(r => r.json());
    
    

    const subtotal = cart.original_total_price / 100;

    const wrapper = document.querySelector(".dd-coupon-list");

    if(!wrapper) return;

    wrapper.innerHTML = "";

    const coupons = [
        //  this is where we upload the coupon which we need to show in the cart
        {
            code:"MOIZ FREEBIES",
            min:999,
            text:"Free MOIZ FREEBIES"
        },

        

        // {
        // code:"FIRST5",
        // min:299,
        // text:"Extra 5% OFF"
        // },

        

    ];

    coupons.forEach(coupon=>{

        const remaining = Math.max(0, coupon.min - subtotal);

    const unlocked = remaining <= 0;

    const iconClass = unlocked ? "" : "dd-grey-icon";   

        wrapper.insertAdjacentHTML(
    "beforeend",
`

<div class="dd-coupon-card">

    <div class="dd-coupon-top">

        <div class="dd-coupon-left">

            <img
            src="https://fe-assets.pickrr.com/discount.gif"
            class="dd-discount-icon ${iconClass}"
            >

            <div class="dd-coupon-code">

                ${coupon.code}

            </div>

        </div>

        <button class="dd-coupon-lock">

            Apply

        </button>

    </div>

    <div class="dd-coupon-message">

        ${
            remaining > 0
            ? `Add more items worth ₹${remaining.toFixed(0)} to apply the offer`
            : `Offer unlocked and applied 🎉`
        }

    </div>

    <div class="dd-coupon-desc">

        ${coupon.text}

    </div>

</div>

`
);

    });

}

document.addEventListener("click",function(e){

    if(!e.target.closest(".dd-coupon-apply")) return;

    const code = document.querySelector(".dd-coupon-search-input").value.trim();

    if(!code) return;

    window.location.href = "/discount/" + code;

});



/*==================================
REMOVE ITEM POPUP
==================================*/

let ddRemoveLine = null;

document.addEventListener("click", async function(e){


    const deleteBtn = e.target.closest(".mini-cart-delete-btn");

if(deleteBtn){
    ddRemoveLine = Number(deleteBtn.dataset.index);

        e.preventDefault();
        e.stopPropagation();

        const item = deleteBtn.closest(".cart-item");

        ddRemoveLine = Number(deleteBtn.dataset.index);

        const image = item.querySelector(".cart-item__media img")?.outerHTML || "";
        const title = item.querySelector(".cart-item__title")?.textContent.trim() || "";
        const variant = item.querySelector(".cart-item__option-value")?.textContent.trim() || "";
        const qty = item.querySelector(".quantity__input")?.value || "";
        const priceEl = item.querySelector(".cart-item__action-price");

let sellingPrice = "";
let mrpPrice = "";

if (priceEl) {
const priceText = priceEl.textContent.trim();

// Find MRP from the existing cart price
const mrpMatch = priceText.match(/MRP\s*₹?\s*[\d,]+(?:\.\d+)?/i);

if (mrpMatch) {
    mrpPrice = mrpMatch[0];

    // Everything before MRP = selling price
    sellingPrice = priceText
        .replace(mrpMatch[0], "")
        .trim();
} else {
    sellingPrice = priceText;
}
}

document.getElementById("ddRemoveProduct").innerHTML = `
<div class="dd-remove-product">

    <div class="dd-remove-product-image">
        ${image}
    </div>

    <div class="dd-remove-product-content">
        <div class="dd-remove-product-title">
            ${title}
        </div>

        <div class="dd-remove-product-variant">
            ${variant}
        </div>

        <div class="dd-remove-product-qty">
            Qty : ${qty}
        </div>
    </div>

    <div class="dd-remove-product-price">

        <span class="dd-remove-selling-price">
            ${sellingPrice}
        </span>

        ${
            mrpPrice
            ? `
                <span class="dd-remove-mrp">
                    ${mrpPrice}
                </span>
            `
            : ""
        }

    </div>

</div>
`;

        document.getElementById("ddRemovePopup").classList.add("show");

        return;
    }

    if(e.target.closest("#ddRemoveClose")){

        document.getElementById("ddRemovePopup").classList.remove("show");

        return;
    }

    if(e.target.id === "ddRemovePopup"){

        document.getElementById("ddRemovePopup").classList.remove("show");

        return;
    }

    // REMOVE
if(e.target.closest("#ddConfirmRemove")){

    const btn = document.getElementById("ddConfirmRemove");

    btn.disabled = true;

    await fetch("/cart/change.js", {
method: "POST",
headers: {
    "Content-Type": "application/json"
},
body: JSON.stringify({
    line: Number(ddRemoveLine),
    quantity: 0
})
});

document.getElementById("ddRemovePopup").classList.remove("show");

await refreshCart();

document.dispatchEvent(
new CustomEvent("cart:refresh", {
    detail: {
        open: true
    }
})
);

btn.disabled = false;

    return;

}

});


//     function isBundle(item) {
//     return item.product_type &&
//            item.product_type.toLowerCase() === "combos";
// }

// function isBundle(item) {
//     if (!item.product_type) return false;

//     const excludedTypes = [
//         "combos",
//         "care lotion"
//     ];

//     return excludedTypes.includes(item.product_type.toLowerCase().trim());
// }

function isBundle(item) {
// Catches every bundle by SKU convention, regardless of product_type
return item.sku && item.sku.toLowerCase().startsWith("bundle_");
}

/* ==================================================
   START DIPESH
   GIFT CARD DETECTION
   Gift Cards do NOT qualify for freebie/discount progress cart2.0
   ================================================== */

function isGiftCard(item) {

const productType = (item.product_type || "").toLowerCase().trim();
const title = (item.title || "").toLowerCase().trim();
const handle = (item.handle || "").toLowerCase().trim();

return (
    productType.includes("gift card") ||
    title.includes("gift card") ||
    handle.includes("gift-card") ||
    handle.includes("giftcard")
);

}

/* ==================================================
   END DIPESH cart2.0
   ================================================== */


/* ==================================================
   START DIPESH
   DISABLE MOIZ FREEBIE IMAGE + PRODUCT LINK
   ================================================== */

document.addEventListener("click", function(e) {

// Detect ONLY the Moiz Freebie card
const freebieCard = e.target.closest(
    ".dd-freebie-card, .moiz-freebie"
);

if (!freebieCard) return;

// If anything inside the freebie is an <a>,
// completely stop that link
const freebieLink = e.target.closest("a");

if (freebieLink && freebieCard.contains(freebieLink)) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    return false;
}

}, true);


/* ==================================================
   BLOCK DIRECT MOIZ FREEBIE ADD TO CART
   ================================================== */

document.addEventListener("submit", function(e){

    const form = e.target;

    if(!form || form.tagName !== "FORM"){
        return;
    }


    const action =
        (form.getAttribute("action") || "")
        .toLowerCase();


    if(!action.includes("/cart/add")){
        return;
    }


    const variantInput =
        form.querySelector(
            'input[name="id"], select[name="id"]'
        );


    if(!variantInput){
        return;
    }


    if(
        String(variantInput.value) ===
        String(DD.FREE_GIFT_VARIANT)
    ){

        if(!window.DD_GIFT_ENGINE_ADDING){

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();


            console.warn(
                "DD FREEBIE BLOCKED: Direct product form add."
            );


            alert(
                "This product is available only as a free gift on qualifying orders of ₹999 or more."
            );


            return false;

        }

    }

}, true);

/* ==================================================
   END DIPESH
   ================================================== */